import PropTypes from 'prop-types'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import Option from './Option'

import './index.scss'

/**
 * @example
 * <Select
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Select" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   required
 * >
 *   <Select.Option key="ABC" value="ABC">
 *     <FormattedMessage id="SomeOption.ABC" defaultMessage="Option ABC" />
 *   </Select.Option>
 *   <Select.Option key="DEF" value="DEF">
 *     <FormattedMessage id="SomeOption.DEF" defaultMessage="Option DEF" />
 *   </Select.Option>
 *   <Select.Option key="123" value="123">
 *     <FormattedMessage id="SomeOption.123" defaultMessage="Option 123" />
 *   </Select.Option>
 * </Select>
 */
const Select = ({ children, variant, className, options, defaultValue, ...props }: any) => (
  <Field
    {...props}
    className={cn('form__select', className, { 'material-outlined': variant === 'material-outlined' })}
    render={({ formik, ...field }: any) => (
      <div className="field__wrapper">
        <select {...field} onBlur={formik.handleBlur} onChange={formik.handleChange} defaultValue={defaultValue}>
          {options
            ? options.map(({ label, value, ...props }: any, index: any) => (
                <Option key={`${value}-${index}`} value={value} {...props}>
                  {label}
                </Option>
              ))
            : children}
        </select>
      </div>
    )}
  />
)

Select.Option = Option

Select.displayName = 'Select'

Select.propTypes = {
  ...propTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      className: PropTypes.string,
      disabled: PropTypes.bool
    })
  ),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  defaultValue: PropTypes.string,
  value: PropTypes.string
}

Select.defaultProps = {
  ...defaultProps,
  children: [],
  className: '',
  options: null
}
export default Select
